import BsButton from "./src/button.vue"
 BsButton.install = function(Vue){
     Vue.component(BsButton.name,BsButton)
 }
 export default BsButton


// WEBPACK FOOTER //
// ./src/components/en/packages/button/index.js